export const FacDashboard = [
  {
    stage: 0,
    page_number: 1,
    page_items: 30
  },
  {
    stage: 1,
    page_number: 1,
    page_items: 30
  },
  {
    stage: 2,
    page_number: 1,
    page_items: 30
  },
  {
    stage: 3,
    page_number: 1,
    page_items: 30
  },
  {
    stage: 4,
    page_number: 1,
    page_items: 30
  },
  {
    stage: 5,
    page_number: 1,
    page_items: 30
  }
];

export const FacsDefault = [
  {
    facs: [],
    title: ''
  },
  {
    facs: [],
    title: ''
  },
  {
    facs: [],
    title: ''
  },
  {
    facs: [],
    title: ''
  },
  {
    facs: [],
    title: ''
  },
  {
    facs: [],
    title: ''
  }
];

export const FacsTemp = [
  {id: 1, name: 'Quente', icon: 'hot'},
  {id: 2, name: 'Morno', icon: 'warm'},
  {id: 3, name: 'Frio', icon: 'cold'}
];

export const FacsChanger = [
  {id: 1, name: 'Verde', icon: 'dot-green'},
  {id: 2, name: 'Amarelo', icon: 'dot-yellow'},
  {id: 3, name: 'Vermelho', icon: 'dot-alert'}
];

export const createTimeMock = {
  field: 'creation_date',
  date: {
    from: null,
    to: null,
  },
  hour: {
    from: '',
    to: '',
  }
};

export const updateTimeMock = {
  field: 'stage_update_date',
  date: {
    from: null,
    to: null,
  },
  hour: {
    from: '',
    to: '',
  }
};
